import { c as _c } from "react/compiler-runtime";
import KommerPoster from 'src/components/kommendefilmer/KommerPoster';
import KommerTextRow from 'src/components/kommendefilmer/KommerTextRow';
import SPosterContainer from 'src/components/kommendefilmer/PosterContainer';
import SSectionTitle from 'src/components/kommendefilmer/SectionTitle';
import STextListContainer from 'src/components/kommendefilmer/TextListContainer';
import { format, isSameYear, parse } from "date-fns";
import { locale } from "src/lib/locale/date-fns";
import styles from "./MonthlyMovies.module.css";
import type { Movie } from 'src/lib/movieinfo/movieinfotypes';
;

//#region [Props]
type MonthlyMoviesPostersProps = {
  monthKey: number;
  movies?: Movie[];
  showTextList: boolean;
};
//#endregion

//#region [Component]
export default function MonthlyMovies(t0) {
  const $ = _c(35);
  const {
    monthKey,
    movies,
    showTextList
  } = t0;
  if ((movies?.length ?? 0) === 0) {
    return null;
  }
  let dateFormat;
  let t1;
  if ($[0] !== monthKey) {
    const d = new Date();
    const month = parse(monthKey.toFixed(2), "yyyy.MM", d);
    dateFormat = isSameYear(month, d) ? "thisyear" : "year";
    t1 = format(month, "MMMM yyyy", {
      locale
    });
    $[0] = monthKey;
    $[1] = dateFormat;
    $[2] = t1;
  } else {
    dateFormat = $[1];
    t1 = $[2];
  }
  const monthTitle = t1;
  if (showTextList) {
    let t2;
    if ($[3] !== monthTitle) {
      t2 = <SSectionTitle>{monthTitle}</SSectionTitle>;
      $[3] = monthTitle;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    let t3;
    if ($[5] !== dateFormat || $[6] !== movies) {
      let t4;
      if ($[8] !== dateFormat) {
        t4 = movie => <KommerTextRow key={movie.mainVersionId} film={movie} dateFormat={dateFormat} />;
        $[8] = dateFormat;
        $[9] = t4;
      } else {
        t4 = $[9];
      }
      t3 = movies.filter(_temp).map(t4);
      $[5] = dateFormat;
      $[6] = movies;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    let t4;
    if ($[10] !== dateFormat || $[11] !== movies) {
      let t5;
      if ($[13] !== dateFormat) {
        t5 = movie_0 => <KommerTextRow key={movie_0.mainVersionId} film={movie_0} dateFormat={dateFormat} />;
        $[13] = dateFormat;
        $[14] = t5;
      } else {
        t5 = $[14];
      }
      t4 = movies.filter(_temp2).map(t5);
      $[10] = dateFormat;
      $[11] = movies;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    let t5;
    if ($[15] !== t2 || $[16] !== t3 || $[17] !== t4) {
      t5 = <STextListContainer>{t2}{t3}{t4}</STextListContainer>;
      $[15] = t2;
      $[16] = t3;
      $[17] = t4;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    return t5;
  }
  let t2;
  if ($[19] !== monthTitle) {
    t2 = <SSectionTitle>{monthTitle}</SSectionTitle>;
    $[19] = monthTitle;
    $[20] = t2;
  } else {
    t2 = $[20];
  }
  let t3;
  if ($[21] !== dateFormat || $[22] !== movies) {
    let t4;
    if ($[24] !== dateFormat) {
      t4 = movie_1 => <KommerPoster key={movie_1.mainVersionId} film={movie_1} dateFormat={dateFormat} height={300} />;
      $[24] = dateFormat;
      $[25] = t4;
    } else {
      t4 = $[25];
    }
    t3 = movies.filter(_temp3).map(t4);
    $[21] = dateFormat;
    $[22] = movies;
    $[23] = t3;
  } else {
    t3 = $[23];
  }
  let t4;
  if ($[26] !== dateFormat || $[27] !== movies) {
    let t5;
    if ($[29] !== dateFormat) {
      t5 = movie_2 => <KommerPoster key={movie_2.mainVersionId} film={movie_2} dateFormat={dateFormat} height={300} />;
      $[29] = dateFormat;
      $[30] = t5;
    } else {
      t5 = $[30];
    }
    t4 = movies.filter(_temp4).map(t5);
    $[26] = dateFormat;
    $[27] = movies;
    $[28] = t4;
  } else {
    t4 = $[28];
  }
  let t5;
  if ($[31] !== t2 || $[32] !== t3 || $[33] !== t4) {
    t5 = <SPosterContainer className={styles.MonthlyMovies}>{t2}{t3}{t4}</SPosterContainer>;
    $[31] = t2;
    $[32] = t3;
    $[33] = t4;
    $[34] = t5;
  } else {
    t5 = $[34];
  }
  return t5;
}
//#endregion
function _temp4(m_2) {
  return !m_2.isPremiereConfirmed;
}
function _temp3(m_1) {
  return m_1.isPremiereConfirmed;
}
function _temp2(m_0) {
  return !m_0.isPremiereConfirmed;
}
function _temp(m) {
  return m.isPremiereConfirmed;
}